import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'kt-action-notification',
  templateUrl: './action-notification.component.html',
  styleUrls: ['./action-notification.component.scss'],
})
export class ActionNotificationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      snackBar: MatSnackBar;
      type: 'INFO' | 'ERROR';
      message: string;
      showCloseBtn: boolean;
    },
  ) {}

  dismiss(): void {
    this.data.snackBar.dismiss();
  }

  getCloseColor(type) {
    switch (type) {
      case 'ERROR':
        return 'ks-btn-flat-danger';
      case 'SUCCESS':
        return 'ks-btn-flat-success';
      case 'INFO':
        return 'ks-btn-flat-neutral';
      default:
        return 'ks-btn-flat-neutral';
    }
  }
}
